import axios from 'axios';
import store from '../../store/index';

export default {
	getAbsenceStatistics({ startDate, endDate, statuses }) {
		const params = new URLSearchParams({ startDate, endDate });
		if (Array.isArray(statuses) && statuses.length > 0) {
			statuses.forEach((status) => {
				params.append('statuses', status);
			});
		}
		const queryString = params.toString();
		return axios.get(`/api/absences/statistics?${queryString}`);
	},
};
